import React from 'react';
import {PlotTypes} from "../Generic/RiskCurvesPlot";

export interface AcceptanceLinesContext {
	data: any;
	setCurrentAcceptanceLines: (acceptanceLines: any) => void;
}

export const saveAcceptanceLines = (data: any) => {
	localStorage.setItem('acceptance_lines', JSON.stringify(data));
}

let getAcceptanceLines: any = JSON.parse(localStorage.getItem("acceptance_lines"));
if (!getAcceptanceLines || !getAcceptanceLines.assets || getAcceptanceLines.assets && !getAcceptanceLines.assets[PlotTypes.COMBINED_IMPACT]) {
	let newAcceptanceLines = {
		...getAcceptanceLines,
		tline: {
			...getAcceptanceLines && getAcceptanceLines.tline
		},
		assets: {
			...getAcceptanceLines && getAcceptanceLines.assets,
			[PlotTypes.COMBINED_IMPACT]: {
				point1: ["0.1", "0.9"],
				point2: ["0.9", "0.001"]
			}
		}
	}
	saveAcceptanceLines(newAcceptanceLines);
	getAcceptanceLines = JSON.parse(localStorage.getItem("acceptance_lines"))
}

export const ACCEPTANCE_LINES_DEFAULT_VALUE = {
	data: getAcceptanceLines,
	setCurrentAcceptanceLines: () => {}
}

export const acceptanceLinesContext = React.createContext<AcceptanceLinesContext>(ACCEPTANCE_LINES_DEFAULT_VALUE)

export const useAcceptanceLines = (): AcceptanceLinesContext => {
	const [data, setAcceptanceLines] = React.useState(getAcceptanceLines);
	const setCurrentAcceptanceLines = React.useCallback((acceptanceLines: any): void => {
		setAcceptanceLines(acceptanceLines);
		saveAcceptanceLines(acceptanceLines);
	}, []);

	return {
		data,
		setCurrentAcceptanceLines
	}
}